import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Ministries from "@/components/Ministries";
import HomeAnnouncements from "@/components/HomeAnnouncements";
import LatestYouTubeVideo from "@/components/LatestYouTubeVideo";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <About />
      <Services />
      <Ministries />
      <HomeAnnouncements />
      <LatestYouTubeVideo />
      <Contact />
      <Footer />
    </div>
  );
};

export default Index;
